<!-- App.vue -->
<template>
  <div id="app">
    <loading></loading>

    <!-- 需要缓存的路由 -->
    <keep-alive>
      <router-view v-if="isRoutreAlive && $route.meta.keepAlive" />
    </keep-alive>

    <!-- 不需要缓存的路由 -->
    <router-view v-if="isRoutreAlive && !$route.meta.keepAlive" />
  </div>
</template>

<script>
import loading from './components/loading/loadingComponent.vue';

export default {
  name: 'app',
  components: {
    loading,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRoutreAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRoutreAlive = false;
      this.$nextTick(() => {
        this.isRoutreAlive = true;
      });
    },
  },
};
</script>